import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { IsNullOrEmpty } from "../../helpers/utility";
import { getCategoryList } from "../../store/shopping/shopping.selector";
import { getImage, getSearchedUsers } from "../../store/user/user.selector";
import { editVIPCircleRequest } from "../../store/user/vipcircle/vipcircle.actions";
import { getCurrentVIPCircle } from "../../store/user/vipcircle/vipcircle.selector";
import { createLiveStreamRequest } from "../../store/social/social.actions";
import {
    Avatar,
    Box,
    Button,
    Card,
    CardContent,
    Container,
    Grid,
    Typography,
} from "@material-ui/core";
import AddBoxOutlinedIcon from "@material-ui/icons/AddBoxOutlined";
import { useStyles } from "../../components/common/MainStyles.jsx";
import pic1 from "../../assets/images/setUpMeetingVIP.png";
import { AddCircleOutlineOutlined } from "@material-ui/icons";

export default function SelectVIPCircle(props) {
    const history = useNavigate();
    const dispatch = useDispatch();
    const classes = useStyles();
    const [selectedCircle, setSelectedCircle] = useState({});
    const { vipCircles, categories, users } = useSelector((state) => {
        return {
            vipCircles: getCurrentVIPCircle(state),
            categories: getCategoryList(state),
            users: getSearchedUsers(state),
        };
    });

    const handleLive = () => {
        let selectedCategory = categories.filter(
            (x) => x.name === "VIP Circle"
        );
        if (selectedCategory.length > 0) {
            selectedCategory = selectedCategory[0];
        }

        let data = {
            type: "main",
            category: selectedCategory._id,
            title: selectedCircle.title,
            contents: selectedCircle.description,
            parent: selectedCircle._id,
            products: [],
            guests: [],
        };
        dispatch(
            createLiveStreamRequest({
                data: data,
                history: history,
            })
        );
    };

    const CloseMe = () => {
        if (props.onClose) {
            props.onClose();
        } else {
            history("/page/start-new-video");
        }
    };

    return (
        <main className={classes.main}>
            <Grid container className="h-[100%]">
                <Grid item xs={12} sm={12} lg={8} md={8}>
                    <Container maxWidth="xl" className="my-4">
                        <Box
                            display="flex"
                            justifyContent="space-between"
                            className="mb-4"
                        >
                            <Typography
                                variant="h5"
                                component="p"
                                className={classes.title}
                            >
                                VIP Circle
                            </Typography>
                            <Button
                                className="text-primary"
                                onClick={() => {
                                    dispatch(editVIPCircleRequest({}));
                                    history("/page/create_vip_circle");
                                }}
                            >
                                <AddCircleOutlineOutlined />
                                &nbsp;Add circle
                            </Button>
                        </Box>
                        <Box
                            className="list-vip"
                            display={"flex"}
                            justifyContent="space-between"
                            flexDirection={"column"}
                        >
                            <Grid container spacing={1} className="my-4">
                                {vipCircles.map((item) => {
                                    let isActive =
                                        selectedCircle._id === item._id;
                                    return (
                                        <Grid
                                            item
                                            sm={12}
                                            xs={12}
                                            lg={4}
                                            md={4}
                                        >
                                            <Card
                                                elevation={0}
                                                style={{
                                                    border: isActive
                                                        ? "2px solid #0038FF"
                                                        : "1px solid #CECECE",
                                                }}
                                                onClick={() => {
                                                    setSelectedCircle(item);
                                                }}
                                            >
                                                <CardContent>
                                                    <Box
                                                        textAlign="center"
                                                        display={"flex"}
                                                        justifyContent="center"
                                                        alignItems={"center"}
                                                        flexDirection={"column"}
                                                    >
                                                        <Avatar
                                                            variant="square"
                                                            style={{
                                                                height: 128,
                                                                width: 128,
                                                            }}
                                                            src={getImage(
                                                                item.avatar
                                                            )}
                                                            title={item.title}
                                                            alt={item.title}
                                                        />
                                                        <span
                                                            className="text-medium my-2 overflow-text"
                                                            style={{
                                                                fontWeight:
                                                                    isActive
                                                                        ? 700
                                                                        : 400,
                                                                color: isActive
                                                                    ? "#0038FF"
                                                                    : "#000",
                                                            }}
                                                        >
                                                            {item.title}
                                                        </span>
                                                    </Box>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    );
                                })}
                            </Grid>
                        </Box>
                        <Box display="flex" className="mt-4">
                            <Button
                                className="m-2"
                                variant="contained"
                                color="default"
                                onClick={() => CloseMe()}
                            >
                                Previous
                            </Button>
                            <Button
                                className="ml-2"
                                disabled={IsNullOrEmpty(selectedCircle._id)}
                                variant="contained"
                                color={
                                    IsNullOrEmpty(selectedCircle._id)
                                        ? "default"
                                        : "secondary"
                                }
                                onClick={() => handleLive(true)}
                            >
                                Start Live
                            </Button>
                        </Box>
                    </Container>
                </Grid>
                <Grid item xs={12} sm={12} lg={4} md={4}>
                    <Box className="side-image-box">
                        <img
                            src={pic1}
                            className="img-responsive  rounded-xl"
                        />
                    </Box>
                </Grid>
            </Grid>
        </main>
    );
}
